module.exports = __webpack_public_path__ + "static/media/Beca Logo Black.10f883e2.png";